import { useState } from 'react';

interface DetailGalleryProps {
  images: string[];
  name: string;
}

export default function DetailGallery({ images, name }: DetailGalleryProps) {
  const [index, setIndex] = useState(0);
  const current = images[index] ?? images[0];

  const go = (dir: number) => {
    setIndex((v) => (v + dir + images.length) % images.length);
  };

  return (
    <div className="w-full">
      <div className="relative w-full h-64 md:h-[360px] rounded-lg overflow-hidden bg-background-100 border border-background-200">
        <img
          src={current}
          alt={`${name} 界面截图 ${index + 1}`}
          title={`${name} 黄金投资软件截图`}
          className="w-full h-full object-cover object-top"
        />
        {images.length > 1 && (
          <>
            <button
              type="button"
              onClick={() => go(-1)}
              aria-label="上一张"
              className="absolute left-3 top-1/2 -translate-y-1/2 w-9 h-9 rounded-full bg-secondary-950/60 hover:bg-secondary-950/85 text-background-50 flex items-center justify-center cursor-pointer transition-colors"
            >
              <i className="ri-arrow-left-s-line text-xl" />
            </button>
            <button
              type="button"
              onClick={() => go(1)}
              aria-label="下一张"
              className="absolute right-3 top-1/2 -translate-y-1/2 w-9 h-9 rounded-full bg-secondary-950/60 hover:bg-secondary-950/85 text-background-50 flex items-center justify-center cursor-pointer transition-colors"
            >
              <i className="ri-arrow-right-s-line text-xl" />
            </button>
            <span className="absolute bottom-3 right-3 px-2 py-1 rounded bg-secondary-950/70 text-background-50 text-xs">
              {index + 1} / {images.length}
            </span>
          </>
        )}
      </div>
      {images.length > 1 && (
        <div className="mt-3 flex items-center gap-3 overflow-x-auto">
          {images.map((img, i) => (
            <button
              key={img}
              type="button"
              onClick={() => setIndex(i)}
              className={`shrink-0 w-24 h-16 rounded-md overflow-hidden border-2 cursor-pointer transition-colors ${
                i === index ? 'border-primary-500' : 'border-background-200 hover:border-primary-300'
              }`}
            >
              <img
                src={img}
                alt={`${name} 缩略图 ${i + 1}`}
                className="w-full h-full object-cover object-top"
              />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}